export * from './fontawesome.service';
